import React, { forwardRef } from 'react';
import {
  makeStyles,
  StandardTextFieldProps,
  TextField,
} from '@material-ui/core';
import { FieldErrors } from 'react-hook-form';
import { get } from 'lodash';

export interface InputTextProps extends StandardTextFieldProps {
  errors: FieldErrors;
  helperText?: string;
  name: string;
}

const useStyles = makeStyles(() => ({
  label: {
    fontSize: '14px',
  },
  shrinkLabel: {
    fontSize: '16px',
  },
}));

/** Wrapper around the material-ui `TextField`.
 *  @param errors - `react-hook-form` provides this object. It contains errors indexed by the `name` property.
 *  @param name - we must provide a `name`, `react-hook-form` uses this internally to keep track of the value & errors.
 *  @param helperText - helper text appears below the input element. This will get overridden by the error
 *    if there is one.w
 *  @param ref - we must provide a ref, `react-hook-form` uses it internally. */
export const InputText = forwardRef(
  ({ name, errors, helperText, ...props }: InputTextProps, ref) => {
    const classes = useStyles();

    return (
      <TextField
        {...props}
        error={!!get(errors, name)}
        inputRef={ref}
        name={name}
        helperText={get(errors, `${name}.message`) || helperText}
        variant="outlined"
        fullWidth
        InputLabelProps={{
          classes: {
            root: classes.label,
            // Need to set the 'shrink label' to 16px because MUI will
            // scale it down by 75%
            shrink: classes.shrinkLabel,
          },
          ...props.InputLabelProps,
        }}
      />
    );
  },
);
